import { MatSpinner, MatProgressSpinner } from '@angular/material/progress-spinner';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { SidebarComponent } from "../sidebar-component/sidebar-component";
import { HeaderComponent } from '../header-component/header-component';
import { FooterComponent } from '../footer-component/footer-component';
import { AuthService } from '../../auth/services/auth-service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { ToastrService } from '../../shared/services/toastr-service';
import { confirmPassword } from '../../shared/validators';


interface ModalDataI{
  title : string
}

@Component({
  selector: 'app-main-component',
  imports: [SidebarComponent, HeaderComponent, FooterComponent],
  templateUrl: './main-component.html',
  styleUrl: './main-component.css',
})

export class MainComponent {

  readonly dialog = inject(MatDialog);
  constructor(
    private authService : AuthService
  ){}

  ngAfterViewInit(): void {
    if(this.authService.getCurrentUser().user.change_password)
      this.openActiveModal()

  }

  openActiveModal(){
    const data : ModalDataI = {
      title : 'Activer votre compte',
    }

    const dialogRef = this.dialog.open(ActiveAccountComponentModal, {
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });
  }

}



@Component({
  selector: 'app-active-account-modal',
  imports: [
    MatDialogActions,
    MatDialogContent,
    MatDialogTitle,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatSpinner
  ],
  templateUrl: './../modals/active-account.html',
  styleUrl: './../modals/active-account.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActiveAccountComponentModal {
  readonly dialogRef = inject(MatDialogRef<ActiveAccountComponentModal>);

  // recupere les donnees envoyes par le parent
  readonly inputData = inject<ModalDataI>(MAT_DIALOG_DATA);

  activeForm : FormGroup = new FormGroup({})

  loading = signal<boolean>(false)

  constructor(
    private fb : FormBuilder,
    private authService : AuthService,
    private toastr : ToastrService
  ){

  }

  ngOnInit(): void {
    this.activeForm = this.fb.group({
      username : ['', [Validators.required, Validators.minLength(6)]],
      passwordGroup : this.fb.group({
        password : ['', [Validators.required, Validators.minLength(5)]],
        confirmPassword : ['', [Validators.required, Validators.minLength(5)]]
      }, {validators : confirmPassword})
    })
  }

  ngAfterViewInit(): void {

  }

  onSave(){
    this.loading.update(val => true)
    const user = this.authService.getCurrentUser()
    const data = {
      user : user.user.id,
      username : this.activeForm.get('username')?.value,
      password : this.activeForm.get('passwordGroup')?.get('password')?.value
    }

    this.authService.activeAccount(data).subscribe({
      next : (res) =>{
        if(res){
          user.user.change_password = false
          this.authService.updateCurrentUser(user)
          this.dialogRef.close()
          this.authService.logout()
          this.toastr.success("Compte active")
          this.toastr.info("Veuillez vous reconnecter")
        }
        this.loading.update(val => false)
      },
      error : (err) =>{
        this.toastr.error("Une erreur est survenue")
        this.loading.update(val => false)
      }
    })
  }

}
